import React from 'react';
import { connect } from 'react-redux';
import {
    Modal,
} from 'react-bootstrap';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import * as SVGICONS from '../../images/img/images';
// import * as signinActions from '../../actions/signinActions';
import * as appointmentActions from '../../actions/appointmentActions';
import * as specialistActions from '../../actions/specialistActions';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import './BlockAvailability.css'
import { blockingTimeArray, REASONOFBLOCKING, blockingMonth, generateUTCStartEndTiming } from './timeSLot';
class BlockAvailability extends React.Component {
    constructor(props, context) {
        super(props, context);
        var todayDate = moment.utc(new Date());
        var convertDate = new Date(moment(todayDate).local());
        var currenthour = moment(todayDate).local().format("HH")
        var currentmin = moment(todayDate).local().format("mm")
        this.state = {
            finalTimeSlotReset: blockingTimeArray,
            finalTimeSlot: blockingTimeArray,
            finalEndTimeSlot: blockingTimeArray,
            blockingDate: convertDate,
            // initialTimeSlots: TimeSLots,
            // finalTimeSlot :  TimeSLots,
            selectedAppointmentDate: Date,
            currenthour: currenthour,
            currentmin: currentmin,
            fetchSpecialistData: false,
            appointmentDatesGetched: false,
            isLoading: true,
            specialistDetail: [],
            startTime: blockingTimeArray[0],
            endTime: blockingTimeArray[1],
            reasonForBlocking: [],
            finalBlockingObj: {
                startDate: null,
                endDate: null,
                reason: REASONOFBLOCKING[0],
                noOfRecursion: 20,
                startTime: null,
                endTime: null,
                daysBlocked: [
                    'tuesday', 'wednesday', 'friday'
                ],
            },
            dateToBlock: convertDate.getDate(),
            monthToBlock: convertDate.getMonth() + 1,
            editTabClicked: false

        };
    }

    componentDidMount() {
        if (this.props.editTabClicked) {
            let { startTime, endTime, recurrence, startDate, reason } = this.props.editProps;
            
            if (recurrence == 'dailyBlockAvailability')
                this.setState({
                    selectedPeriod: 'daily'
                })
            if (recurrence == 'weeklyBlockAvailability')
                this.setState({
                    selectedPeriod: 'weekly'
                })
            if (recurrence == 'monthlyBlockAvailability')
                this.setState({
                    selectedPeriod: 'monthly'
                })
            if (recurrence == 'yearlyBlockAvailability')
                this.setState({
                    selectedPeriod: 'yearly'
                })
            this.setState({
                // DAYSOFMONTH,
                reasonForBlocking: REASONOFBLOCKING,
                reason: REASONOFBLOCKING[0],
                startTime,
                endTime,
                blockingDate: startDate,
                editTabClicked: true
                // finalBlockingObj: {
                //     ...this.state.finalBlockingObj,
                //     startDate
                // }
            })

        } else {
            this.setState({ reasonForBlocking: REASONOFBLOCKING, reason: REASONOFBLOCKING[0] })
            this.props.changeReasonForBlocking(REASONOFBLOCKING[0]);
        }

        // let userToken = localStorage.getItem('token');
        // let specialistId = localStorage.getItem('userId');

        // let settingsObj = {
        // 	token: userToken,
        // 	doctorId: specialistId
        // };

        // this.props.actions.getDetailsForSpecialistAvailability(settingsObj);
        // this.setState({fetchSpecialistData: true})
    }
    //   componentWillReceiveProps (nextProps) {
    //     if (nextProps.specialistDetail && this.state.fetchSpecialistData) {
    // 		this.setState({
    //             specialistDetail: nextProps.specialistDetail,
    //             fetchSpecialistData: false
    // 		}, () => {
    // 			let appointmentObj = {
    // 				...this.state.specialistDetail[0],
    // 				currenthour: this.state.currenthour,
    // 				currentmin: this.state.currentmin,
    // 				appointmentDate: this.state.appointmentDate,
    // 				userlocation: moment.tz.guess(),
    // 				avail: true
    // 			}
    //             this.props.appointmentactions.getSpecialistAvailability(appointmentObj, this.props);
    //             this.setState({appointmentDatesGetched: true})
    // 		})
    //     }

    //   }
    handleChangeStartTime = selectedOption => {

        let valueForEndTime = this.state.finalTimeSlotReset;
        valueForEndTime.forEach((value, i) => {
            if (value.value == selectedOption.value) {
                // 
                // return i;
                let newArray = valueForEndTime.slice(i + 1, valueForEndTime.length)

                this.setState({
                    finalEndTimeSlot: newArray,
                    startTime: selectedOption,
                    endTime: newArray[0],
                    finalBlockingObj: {
                        ...this.state.finalBlockingObj,
                        startDate: selectedOption.value,
                        startTime: selectedOption.value
                    }
                }, () => {

                });
            }
        });
    };

    // handleChangeEndTime = selectedOption => {
    //     
    //     let valueForStartTime = this.state.initialTimeSlots;
    //     
    //     valueForStartTime.forEach((value, i) => {
    //         if (value.value == selectedOption.value) {
    //             let newArray = valueForStartTime.slice(0, i)
    //             this.setState({ 
    //                 finalTimeSlot : newArray,
    //                 endTime: selectedOption,
    //                 finalBlockingObj : { 
    //                     ...this.state.finalBlockingObj, 
    //                     endDate: selectedOption.value,
    //                     endTime: selectedOption.value

    //                 }
    //              }, ()=> {
    //                  
    //              });
    //         }
    //     });
    // };

    handleChangeEndTime = selectedOption => {
        let valueForStartTime = this.state.finalTimeSlotReset;
        valueForStartTime.forEach((value, i) => {
            if (value.value == selectedOption.value) {
                // 
                // return i;
                let newArray = valueForStartTime.slice(0, i)
                this.setState({
                    finalTimeSlot: newArray,
                    endTime: selectedOption,
                    finalBlockingObj: {
                        ...this.state.finalBlockingObj,
                        // endDate: selectedOption.value,
                        endTime: selectedOption.value

                    }
                }, () => {

                });
            }
        });
    };
    changeReasonForBlocking = (selectedOption) => {

        this.props.changeReasonForBlocking(selectedOption);
        this.setState({
            reason: selectedOption,
            finalBlockingObj: {
                ...this.state.finalBlockingObj,
                reason: selectedOption.value
            }
        }, () => {


        })
    };

    blockingDateChanged = (selectedDate) => {
        let todayDate = selectedDate
        var convertDate = new Date(moment(todayDate).local());
        // staring from 1 so 
        let yearlyMonthSelected = blockingMonth[convertDate.getMonth() + 1];
        this.setState({
            // daysBlocked: [...this.state.daysBlocked, weeklyDaySelected],
            appointmentDatesGetched: true,
            dateToBlock: convertDate.getDate(),
            monthToBlock: yearlyMonthSelected,
            blockingDate: selectedDate,
        })
        // })

    }
    submitBlockAvailability = (periodToBlock) => {
        //   
        //   if (periodToBlock === 'daily') {
        //       this.props.appointmentactions.dailyBlockAvailability(this.state.finalBlockingObj, this.props);
        //   }
        //   if (periodToBlock === 'weekly') {
        //     this.props.appointmentactions.weeklyBlockAvailability(this.state.finalBlockingObj, this.props);
        //   }
        //   if (periodToBlock === 'monthly') {
        //       let finalBlockingObj = {
        //         blockingDate: this.state.blockingDate,
        //           startTime: this.state.startTime.value,
        //           endTime: this.state.endTime.value,
        //           reason: this.state.reasonForBlocking[0].value,
        //           dateToBlock: this.state.dateToBlock,
        //           noOfRecursion: this.state.finalBlockingObj.noOfRecursion
        //       }
        //       
        //     this.props.appointmentactions.monthlyBlockAvailability(finalBlockingObj, this.props);
        //   }
        let update = false;
        if (this.state.editTabClicked) update = true;
        if (periodToBlock === 'yearly') {
            let blockingDate = this.state.blockingDate,
                startTime = this.state.startTime.value,
                endTime = this.state.endTime.value,
                dateToBlock = this.state.dateToBlock,
                endDate = this.state.blockingDate,
                reason = this.state.reason.label;
            //   let convertedDate = new Date(blockingDate).setHours(3);
            let { startHour, startMinutes, endHour, endMinutes } = generateUTCStartEndTiming({ startTime, endTime });
            var userlocation = moment.tz.guess();

            let finalBlockingObj = {
                blockingDate,
                startTime,
                endTime,
                reason,
                dateToBlock,
                noOfRecursion: 0,
                userlocation,
                specialistId: localStorage.getItem('userId'),
                //   monthToBlock,
                endDate,
                event: this.props.editProps,
                startTiming: new Date(new Date(blockingDate.setHours(startHour)).setMinutes(startMinutes)),
                endTiming: new Date(new Date(blockingDate.setHours(endHour)).setMinutes(endMinutes)),
                offset: blockingDate.getTimezoneOffset()
            }
            
            if (update) {
                finalBlockingObj.recurrence = this.props.editProps.recurrence,
                    finalBlockingObj.exclude = true,
                    finalBlockingObj.excludeId = this.props.editProps._id,
                    finalBlockingObj.excludeDate = this.props.editProps.startDate
                // this.props.actions.deleteRecurringEvents(finalBlockingObj, this.props)
                // this.props.appointmentactions.yearlyBlockAvailability(finalBlockingObj, this.props)

            }
            // return;
            
            this.props.appointmentactions.yearlyBlockAvailability(finalBlockingObj, this.props)

        }
    }

    render() {
        return (
            <Modal className="blockAvailability" show={this.props.openBlockAvailability} size="lg" onHide={this.props.closeBlockAvailability}>
                <Modal.Header closeButton>
                    <Modal.Title align="left">
                        <h4>Appointment Unavailability</h4>

                        <span style={{ marginLeft: "-80px" }} className="tooltip-custom fadeEffect posabr00 pull-right subRight helpsvg mobileposavr00" data-title="Enter blocks of time where you will be unavailable and select the appropriate reason.">
                            <span style={{ width: "18px", marginLeft: "" }}>
                                <SVGICONS.Helppic />
                            </span>
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="loginInput1">
                        <div className="row m-b-10">
                            <div className="col-lg-2" id="inputGroupPrepend">
                                <label className="label">Date</label>
                            </div>
                            <div className="col-lg-9">
                                <div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">
                                    <div className="input-group date inputBg dateInputfild" style={{ color: '#4d4d4d !important' }}>
                                        <div className="input-group-addon">
                                            <img src={require('../../images/img/date_input_icon.svg')} />
                                            {/* <img src={require('../../images/icons/calendar.svg')} /> */}
                                        </div>
                                        <DatePicker
                                            name="blockingdate"
                                            dateFormat="dd-MM-yyyy"
                                            selected={this.state.blockingDate}
                                            onChange={this.blockingDateChanged}
                                            placeholderText="Date"
                                            // maxDate={moment().add(1, 'year')}
                                            minDate={new Date()}
                                            showMonthDropdown
                                            showYearDropdown
                                            shouldCloseOnSelect={true}
                                        // dropdownMode="select"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-1">
                                {this.props.editTabClicked == false ? <div className="text-center"><i className="fa fa-refresh recur" onClick={this.props.recurrenceDaily}></i></div> : ""}
                            </div>
                        </div>
                    </div>
                    <div className="loginInput1">
                        <div className="row m-b-10">
                            <div className="col-lg-2" id="inputGroupPrepend">
                                <label className="label">Time</label>
                            </div>
                            <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                <div className="">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                            <SVGICONS.ScheduleInputSvg />
                                            {/* <img src={require('../../images/icons/circular-wall-clock.svg')} /> */}
                                        </span>
                                        <Select
                                            // styles={customStyles}
                                            value={this.state.startTime}
                                            onChange={this.handleChangeStartTime}
                                            options={this.state.finalTimeSlot}
                                        // defaultValue={this.state.finalTimeSlot[0].value}
                                        />
                                    </div>
                                    <div>
                                        <span className="help-block">{this.props.friday && this.props.fridayEveningSchedule.message}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-5 col-sm-5 col-md-5 col-lg-5">
                                <div className="">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                            <SVGICONS.ScheduleInputSvg />
                                        </span>
                                        <Select
                                            // styles={customStyles}
                                            value={this.state.endTime}
                                            onChange={this.handleChangeEndTime}
                                            options={this.state.finalEndTimeSlot}
                                        />
                                        {/* <small>dsfsdkf;ls</small> */}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="loginInput1">
                        <span id="inputGroupPrepend">
                        </span>
                        <div className="row">
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                <div className="">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                            error on start time
                                        </span>
                                    </div>
                                    <div>
                                        <span className="help-block">{this.props.friday && this.props.fridayEveningSchedule.message}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                <div className="">
                                    <div className="input-group inputBg clock">
                                        <span className="input-group-addon">
                                        error on start time
                                        </span>
                                    </div>  
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="loginInput1">
                        <div className="row">
                            <div className="col-lg-2">
                                <label className="label">Reason</label>
                            </div>
                            <div className="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                                <div className="boxMrgB">
                                    <div className="input-group inputBg reason">
                                        <span className="input-group-addon reasonIcon">
                                            <SVGICONS.BlockReasonInput />
                                        </span>
                                        <Select
                                            // styles={customStyles}
                                            value={this.state.reason}
                                            onChange={this.changeReasonForBlocking}
                                            options={this.state.reasonForBlocking}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="btnSubmit text-center">
                        {/* <button onClick={()=>this.submitBlockAvailability('daily')} className="btn btn-primary">Submit</button> */}
                        {/* <button onClick={()=>this.submitBlockAvailability('weekly')} className="btn btn-primary">Submit</button> */}
                        <button onClick={() => this.submitBlockAvailability('yearly')} className="btn btn-primary">Submit</button>
                        {/* <button onClick={()=>this.submitBlockAvailability('yearly')} className="btn btn-primary">Submit</button> */}
                    </div>


                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal >
        );
    }
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
    return {
        specialistDetail: state.specialist.specialistDetail,
        appointments: state.specialist.appointments,
        specialistAvailability: state.appointment.specialistAvailability,
    };
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(specialistActions, dispatch),
        appointmentactions: bindActionCreators(appointmentActions, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(BlockAvailability);